import createVueApp from '@/common/createApp'

Styxie.Initializers.LindaGoogleAccounts = {
  new: async(props) => {
    const { default: GoogleAccountsNew } = await import('@/vue_widgets/linda/google_accounts/new/index.vue')
    createVueApp(GoogleAccountsNew, { props, layout: null })
  }
}
